<template>
  <div>
    <slot />

    <ForgotPasswordModal v-if="getModal('forgotPassword')" />
    <CreateAccountModal />
  </div>
</template>
<script setup lang="ts">
import ForgotPasswordModal from '~/components/ForgotPasswordModal.vue'
import { useModalStore } from '~/stores/modal'
import CreateAccountModal from '~/components/CreateAccountModal.vue'

const { getModal } = useModalStore()
</script>
